"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReviewCycleReviewReportsDetailsExportEvent", {
    enumerable: true,
    get: function() {
        return ReviewCycleReviewReportsDetailsExportEvent;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const ReviewCycleReviewReportsDetailsExportEvent = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId,
    userId: _utilsisomorphic.transformObjectId,
    jobId: _utilsisomorphic.transformObjectId,
    reviewCycleId: _utilsisomorphic.transformObjectId,
    timezone: _zod.z.string().optional()
});
